<template>
	<page style="background: #fff;">
		<c-form ref="form">
			<c-form-item ref="items" label="盘点明细" name="items" required>
				<template #handle>
					<span style="font-size: .26rem; color: #aaa;"><span style="color: var(--color-main)">{{productList.length}}</span>条记录</span>
				</template>
				<insert-data scan-name="扫码盘点" @scan="scanHandle"></insert-data>
				<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1" remove-button @remove="removeHandle(item, i)">
					<template #title>
						<span class="product-title flex-start-center">
							<c-state v-if="item.level_type" dict="LEVEL_TYPE" :value="item.level_type" type="hollow"></c-state>
							<span>{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span>
						</span>
					</template>

					<template #default>
						<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
						<c-field label="IMEI">{{item.produce_imei || '-'}}</c-field>
						<c-field label="成本价">{{item.purchase_price ? '￥' + item.purchase_price : '-'}}</c-field>
						<c-field label="当前接驳人">{{item.recipient_user_realname || '-'}}</c-field>
					</template>
				</detail-card>
			</c-form-item>
		</c-form>

		<c-dialog ref="lossDialog" title="盘点完成" height="70vh" enable-flex button-name="确认盘点完成" cancel-button cancel-button-name="上一步" @resolve="submitHandle">
			<div class="loss-total flex-start-center">
				<p>盘点总数：<span>{{productList.length}}</span></p>
			</div>
			<c-scroll class="flex-grow">
				<div class="list-title">盘亏背贴码：<b>{{profitLossList.length}}条</b></div>
				<div v-for="(item, i) in profitLossList" :key="i" class="loss-item">
					<p>{{item.produce_unique_code}}</p>
					<p><span>{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span></p>
					<p v-if="item.lend_state == 1 || item.lend_state == 0">
						<span v-if="item.lend_state == 1" class="lend-mark">借出：{{item.lend_borrower_name || '-'}}</span>
						<span v-else>未借出</span>
					</p>
				</div>
				<c-empty v-if="!profitLossList.length" message="无盘亏"></c-empty>

				<div class="list-title profit-title">盘盈背贴码：<b>{{profitList.length}}条</b></div>
				<div v-for="(item, i) in profitList" :key="'profit-' + i" class="loss-item profit-item">
					<p>{{item.produce_unique_code}}</p>
					<p><span>{{[item.brand_name, item.spu_model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span></p>
					<p v-if="item.remark"><span class="profit-remark">{{item.remark}}</span></p>
				</div>
				<c-empty v-if="!profitList.length" message="无盘盈"></c-empty>
			</c-scroll>
			<div class="loss-remark">
				<c-input v-model="remark" type="textarea" placeholder="备注内容填写在这里..." :height-resize="{maxHeight: '1.8rem'}"></c-input>
			</div>
		</c-dialog>

		<template #button>
			<c-button color="main" hollow size="form" @click="mp.navigateBack()">取消</c-button>
			<c-button class="foot-button" size="form" color="main" @click="nextHandle">下一步</c-button>
		</template>
	</page>
</template>

<script>
	export default {
		props: {
			id: [String, Number]
		},

		data() {
			return {
				productList: [],
				profitLossList: [],
				profitList: [],
				remark: ''
			}
		},

		mounted() {
			this.request({
				url: '/inventory/detail',
				data: {
					id: this.id
				},
				success: data => {
					if (data.check_state == 1) {
						this.request({
							url: '/inventory/start',
							data: {
								id: data.id
							}
						});
					}
					this.productList = data.product_list || [];
					this.profitLossList = data.profit_loss_list || [];
				}
			})
		},
		
		methods: {
			scanHandle(code) {
				if (this.productList.some(item => item.produce_unique_code == code)) {
					this.$message({
						message: '该背贴码已存在'
					});
					return;
				}
				this.request({
					url: '/inventory/scan',
					data: {
						id: this.id,
						code: code
					},
					success: data => {
						this.productList.push(data);
					}
				});
			},

			removeHandle(item, index) {
				this.$confirm({
					message: '确认移除该商品？',
					resolve: () => {
						this.request({
							url: '/inventory/remove',
							data: {
								id: this.id,
								ids: [item.id]
							},
							loading: true,
							success: () => {
								this.productList.splice(index, 1);
							}
						});
					}
				});
			},

			nextHandle() {
				this.$refs.form.submit({
					url: '/inventory/loss',
					rule: {
						items: [{
							type: 'function',
							message: '请扫描盘点商品',
							fun: () => {
								return this.productList.length;
							}
						}]
					},
					dataFormatter: () => {
						return {
							id: this.id,
							product_ids: this.productList.map(item => item.id)
						}
					},
					success: (data, res) => {
						this.profitLossList = res.loss_list || [];
						this.profitList = res.profit_list || [];
						this.$refs.lossDialog.open();
					}
				})
			},
			
			submitHandle(stop) {
				stop();
				this.$confirm({
					message: '盘点完成后将不可修改结果，确认完成吗？',
					buttonName: '完成盘点',
					resolve: () => {
						this.request({
							url: '/inventory/post',
							data: {
								id: this.id,
								remark: this.remark
							},
							loading: true,
							success: () => {
								this.$message({
									message: '操作成功',
									mask: true
								});
								this.mp.navigateBack(true);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.loss {
		&-total {
			gap: .3rem;
			height: .64rem;
			padding: 0 .3rem;
			font-size: .26rem;
			color: #666;
			background: #EFF2FF;

			span {
				color: #3D5EFF;
			}

			b {
				color: #f00;
			}
		}

		&-item {
			border-radius: .08rem;
			padding: .14rem .26rem;
			margin: 0 .24rem .16rem;
			line-height: .38rem;
			font-size: .28rem;
			color: #f55;
			background: #FFF5F5;

			span {
				font-size: .24rem;
				color: #666;
			}
		}

		&-remark {
			padding: .24rem .4rem;
			background: #F9F9F9;
		}
	}

	.product-title {
		gap: .1rem;
		flex-wrap: wrap;
	}

	.list-title {
		padding: .24rem .4rem .16rem;
		font-size: .26rem;
		color: #666;

		b {
			color: #f00;
		}
	}

	.profit-title {
		b {
			color: #1890ff;
		}
	}

	.loss-item.profit-item {
		color: #1890ff;
		background: #E6F7FF;
	}

	.loss-item .profit-remark {
		color: #1890ff;
	}

	.loss-item .lend-mark,
	.lend-mark {
		color: #ff6900;
	}
</style>